// src/session.js
// Sessione di accesso: token firmato dal server + utente + copia della
// piattaforma (RaceSense o un cliente). Il token va in ogni chiamata /api
// (vedi apiAuth.js); il server decide cosa si può fare.

import { useEffect, useState } from 'react';

const KEY = 'rs_session_v2';

export function getSession() {
  try {
    const s = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!s || !s.token || !s.user) return null;
    return s;
  } catch {
    return null;
  }
}

export function setSession(s) {
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* storage non disponibile */ }
  window.dispatchEvent(new Event('rs-session'));
}

export function clearSession() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem('rs_auth_ok_v1');   // vecchio gate a password unica
  } catch { /* noop */ }
  window.dispatchEvent(new Event('rs-session'));
}

export const isAdmin = (s = getSession()) => s?.user?.role === 'admin';

// Sezioni acquistate dal cliente ('race', 'training'). L'admin vede tutto;
// per il cliente decide la nostra pagina Clienti (il server applica lo stesso).
export const featureEnabled = (feature, s = getSession()) => s?.features?.[feature] !== false;
export const canUse = (feature, s = getSession()) => isAdmin(s) || featureEnabled(feature, s);

/** Sessione corrente, aggiornata quando cambia (login, logout, refresh). */
export function useSession() {
  const [s, setS] = useState(getSession);
  useEffect(() => {
    const onChange = () => setS(getSession());
    window.addEventListener('rs-session', onChange);
    // rilettura dopo l'iscrizione: un aggiornamento arrivato fra il primo
    // render e questo effetto altrimenti andrebbe perso
    onChange();
    return () => window.removeEventListener('rs-session', onChange);
  }, []);
  return s;
}

// Pagine pubbliche: si aprono senza login (diretta, overlay, link condivisi).
export function isPublicPath(pathname) {
  return pathname.startsWith('/obs')
    || pathname.startsWith('/live/')
    || pathname.startsWith('/pilot/')
    || pathname.startsWith('/training/')
    || pathname.startsWith('/pulse')
    || /^\/gare-passate\/[^/]+/.test(pathname)   // recap di una gara via link
    || pathname === '/login';
}
